import Card from '@/components/Card/Card';
import Input from '@/components/Input/Input';
import styles from './NavigationCodeName.module.css';
import { NavigationCodeNameProps } from '../CreateNavCode.types';
import { Box, Stack, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export const NavigationCodeName = (props: NavigationCodeNameProps) => {
  const { t } = useTranslation();
  const { codeName, valuesList, handleInputChange, handleInputKeyDown } = props;

  return (
    <div className={styles.stepOne}>
      <div className={styles.accordionContainer}>
        <Card>
          <div className={styles.widgetBody}>
            <div className={styles.inputContainer}>
              <Box sx={{ width: '80%' }}>
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" paddingBottom="10px">
                  {valuesList?.map((cname: string) => (
                    <Chip
                      data-testid="icon"
                      key={`${cname}`}
                      label={`${cname}`}
                      deleteIcon={<CloseIcon style={{ color: 'black', fontSize: 'large' }} />}
                      color="default"
                      variant="outlined"
                      sx={{
                        boxShadow: '4',
                        fontSize: '14px',
                        height: '28px',
                      }}
                    />
                  )) || '-'}
                </Stack>
                <Input
                  id="linkedBundleName"
                  label={t('common.bundle.newNavigationCode')}
                  value={codeName}
                  placeholder={t('common.bundle.typeAndEnter')}
                  onChange={handleInputChange}
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  onKeyDown={handleInputKeyDown}
                />
              </Box>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
